<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_7"><span class="txit">For Jane and Peter<br/>who kindly allowed two of my characters to live at 57 Norwich Street.</span></a><a id="page_8"></a></p><a id="page_8">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// a_dedication.vue?2a523608